module.exports = __webpack_public_path__ + "images/erp-nation-glad-top-2026-2027_1016.1792157180594.jpg";